import { FC, useState } from 'react';
import { LoadMore } from 'molecules/LoadMore';
import { ILoadingState } from 'pages/ProductListing/types';
import { gtmPushRelevantVirtualUrl } from 'modules/gtm/modules/sections/page/utils';
import { gtmPushScrollManually } from 'modules/gtm/modules/sections/scroll/scroll';
import { getQueryParam } from 'modules/main/utils';
import { usePathname } from 'modules/next/hooks';
import { ClientPageType } from 'src/app/types';

export const LoadMorePrev: FC<{
  setNewPage: (page: number) => void;
  pageType?: ClientPageType;
}> = ({ setNewPage, pageType }) => {
  const [loadingState, setLoadingState] = useState<ILoadingState>({
    loading: false,
    isLazyLoadingEnable: false,
  });
  const pathname = usePathname();
  const currentSection = Number(getQueryParam('page')) || 1;

  const loadMorePrev = async () => {
    const newSection = currentSection - 1;

    setLoadingState({
      loading: true,
      isLazyLoadingEnable: false,
    });
    await setNewPage(newSection);

    gtmPushRelevantVirtualUrl(pathname, `page=${newSection}`);

    setLoadingState({
      loading: false,
      isLazyLoadingEnable: false,
    });
  };

  const sendScrollManuallyGtmEvent = () =>
    gtmPushScrollManually({
      currentPage: currentSection,
      pageType,
    });

  return (
    <LoadMore
      isLoading={loadingState.loading}
      isPrev
      loadMore={loadMorePrev}
      onClick={sendScrollManuallyGtmEvent}
    />
  );
};
